import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { Virtual } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Product } from "../../../models/home-rows";
import { API } from "../../../services/api-services";
import AppContext from "../../../services/app-context-services";
import { lastNumberPart, _c } from "../../../services/text-services";
import FetchData from "../fetch-data/fetch-data";
import AppSingleProduct from "../single-product/single-product.component";
// @ts-ignore
import styles from "./product-list.component.module.scss";

const TRANSITION_SPEED = 200; // miliseconds
interface AppProductListProps {
  productsArray: Product[];
  isRelatedFile: boolean;
  title: string;
  gaTitle: string;
}

function AppProductList({
  productsArray,
  isRelatedFile,
  title,
  gaTitle
}: AppProductListProps) {
  const [theSwiper, setTheSwiper] = useState<any>();
  const [navIsBeginning, setNavIsBeginning] = useState(true);
  const [navIsEnd, setNavIsEnd] = useState(true);
  const [relatedResponseData, setRelatedResponseData] = useState({
    count: 0,
    position: 0,
    id: 0
  });
  const router = useRouter();
  const appCtx = useContext(AppContext);
  const { isLoggedIn } = appCtx;
  useEffect(() => {
    if (!theSwiper) return;
    theSwiper.update();
    setNavIsBeginning(theSwiper.activeIndex < 1);
    setNavIsEnd(theSwiper.isEnd);
  }, [theSwiper]);

  return (
    <>
      {relatedResponseData.count > 0 && (
        <FetchData
          url={API.request_related_response}
          method="POST"
          body={JSON.stringify({
            position: relatedResponseData.position,
            product_id: lastNumberPart(router?.query?.slug?.[1]),
            product_target_id: relatedResponseData.id
          })}
          onFinally={() => {}}
          counter={relatedResponseData.count}
          unAuthorized={!isLoggedIn}
        />
      )}
      <Swiper
        modules={[Virtual]}
        slidesPerView={8}
        spaceBetween={15}
        virtual
        autoHeight
        className={_c(styles, "recommanded-wrapper d-flex")}
        onAfterInit={swiper => setTheSwiper(swiper)}
        onActiveIndexChange={swiper => {
          setNavIsBeginning(swiper.activeIndex < 1);
          setNavIsEnd(swiper.isEnd);
        }}
        breakpoints={{
          1450: {
            slidesPerView: 8,
            spaceBetween: 15
          },

          1350: {
            slidesPerView: 8,
            spaceBetween: 15
          },
          1200: {
            slidesPerView: 6,
            spaceBetween: 15
          },

          768: {
            slidesPerView: 5,
            spaceBetween: 10
          },

          600: {
            slidesPerView: 4,
            spaceBetween: 5
          },

          400: {
            slidesPerView: 3,
            spaceBetween: 8
          },

          300: {
            slidesPerView: 2,
            spaceBetween: 15
          }
        }}
      >
        {productsArray.map((product, index) => (
          <div
            key={product.id}
            className={_c(styles, "col-lg-3 col-6 mt-2 mb-4 slideItem")}
          >
            <div className="px-1">
              {/* <FeatureItem product={prod as Product} /> */}
              <SwiperSlide key={`prod-${index}`} virtualIndex={index}>
                <AppSingleProduct
                  gaTitle={gaTitle}
                  product={product as Product}
                  isRelatedFile={!!isRelatedFile}
                  relatedResponse={id => {
                    if (isRelatedFile)
                      setRelatedResponseData(prev => ({
                        count: prev.count + 1,
                        id,
                        position: index
                      }));
                  }}
                />
              </SwiperSlide>
            </div>
          </div>
        ))}
        {!navIsEnd && (
          <div
            onClick={() => theSwiper.slideNext(TRANSITION_SPEED, false)}
            className={_c(styles, "next-recommanded nav")}
          >
            ›
          </div>
        )}
        {!navIsBeginning && (
          <div
            onClick={() => theSwiper.slidePrev(TRANSITION_SPEED, false)}
            className={_c(styles, "prev-recommanded nav")}
          >
            ‹
          </div>
        )}
      </Swiper>
    </>
  );
}
export default AppProductList;
